import React from 'react';
import { Trans } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHandPointUp } from '@fortawesome/free-solid-svg-icons';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import { tA11y } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/@common/util/i18n-util';
import useGame from '@monorepo/shared/src/hooks/use-game';
import { SoundOutWordsPage } from '@monorepo/shared/src/graph/schema-generated-types-educator';
import theme from '@monorepo/shared/src/themes/defaultTheme';

const Instructions: React.FC = () => {
  const classes = useStyles();
  const [{ currentData }] = useGame<SoundOutWordsPage>();

  const hasWordsToSpell = currentData?.some(({ words }) => !!words);

  return (
    <div className={classes.placeholder}>
      {hasWordsToSpell && (
        <div className={classes.pointer}>
          <FontAwesomeIcon icon={faHandPointUp} size={'2x'} color={theme.palette.secondary.dark} />
        </div>
      )}
      {hasWordsToSpell && tA11y('activities.SoundOutWordsInstructions')}
      {!hasWordsToSpell && (
        <span>
          <Trans>
            {tA11y('activities.SoundOutWordsInstructionsNoWords.text', {
              activityName: 'Read It Words',
            })}
          </Trans>
        </span>
      )}
    </div>
  );
};

export default Instructions;

const useStyles = makeStyles((theme: Theme) => ({
  placeholder: {
    display: 'flex',
    flexDirection: 'column',
    ...theme.typography.h5,
  },
  pointer: {
    margin: '2rem',
  },
}));
